import clsx from 'clsx';
import React from 'react';
import {
  FilterComponentProps,
  LocalDateTimeField,
  Select,
} from '@eas/common-web';
import { useCompareOperations } from '../filter-api';
import { useStyles } from '../filter-styles';
import { useFilterOperation } from '../hooks/filter-operation-hook';

export function DisabledFilterDateTimeCell(props: FilterComponentProps) {
  return <FilterDateTimeCell {...props} disabled />;
}

export function DisabledFilterDateTimeWithoutOperationCell(
  props: FilterComponentProps
) {
  return <FilterDateTimeCell {...props} hideOperationSelect disabled />;
}

export function FilterDateTimeWithoutOperationCell(
  props: FilterComponentProps
) {
  return <FilterDateTimeCell {...props} hideOperationSelect />;
}

export function FilterDateTimeCell({
  disabled,
  value,
  onChange,
  state,
  onChangeState,
  hideOperationSelect,
}: FilterComponentProps & { hideOperationSelect?: boolean }) {
  const classes = useStyles();
  const operations = useCompareOperations();
  const { handleChangeOperation } = useFilterOperation(state, onChangeState);

  return (
    <div className={clsx(classes.root, { [classes.disabled]: disabled })}>
      {!hideOperationSelect && (
        <div className={classes.selectWrapper}>
          <Select
            source={operations}
            value={state.operation}
            onChange={handleChangeOperation}
            valueIsId={true}
            clearable={false}
            disabled={disabled}
          />
        </div>
      )}
      <div
        className={clsx({
          [classes.textWithoutSelectWrapper]: hideOperationSelect,
          [classes.textWrapper]: !hideOperationSelect,
        })}
      >
        <LocalDateTimeField
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
